import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { INVOICE_CODE } from "../apiRoutes";

const mutateToggleUpdateInvoiceCode = async ({ id }: { id: string | number }) => {
  return await axiosAuth.patch(`${INVOICE_CODE}${id}`);
};

const useToogleUpdateInvoiceCodesMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
			id: string | number;
		},
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateToggleUpdateInvoiceCode,
    ...queryParams,
  });

export default useToogleUpdateInvoiceCodesMutation;
